// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Gupter:wght@400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contenedor_registro_i {
    display: flex;
    flex-direction: row;
    align-items: center; /* Centra horizontalmente */
    justify-content: center; /* Centra verticalmente */
    text-align: center;
}


.principal {
    display: flex;
    flex-direction: row;
    align-items: center; /* Centra horizontalmente */
    justify-content: center; /* Centra verticalmente */
    text-align: center;
    margin-top: 20px;
    margin-bottom: 20px;
}

.formulario_login_i {
    font: 1.4em Gupter;
    display: block;
    justify-content: center; /* Centra las columnas horizontalmente */
    align-items: center; /* Centra las filas verticalmente */
    border: double 7px white;
    background-color:rgb(158, 224, 252, 0.777);
    margin-bottom: 20px;
    margin-top: 20px;
    border-radius: 20px;
    padding-top: 20px;
    padding-bottom: 20px;
}

.titulo_l {
    font: 1.8em Gupter;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    color: white;
    background-color: #545454;
    border: double 7px white;
    border-radius: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
}

.etiqueta_i {
    display: flex;
    justify-content: right; /* Centra las columnas horizontalmente */
    align-items: center; /* Centra las filas verticalmente */
    padding-right: 5px;
    padding-bottom: 10px;
    color: #333;
}

.casilla_i {
    justify-content: center; /* Centra las columnas horizontalmente */
    align-items: center; /* Centra las filas verticalmente */
    padding: 5px;
    border-radius: 5px;
    border: double 7px rgb(170, 157, 152);
    color: coral;
    margin-bottom: 10px;
}


button.boton_login {
    margin-top: 20px;
    color: white;
    background-color: rgb(170, 157, 152);
    padding: 10px;
    border-radius: 20px;
    border: double 7px rgb(158, 224, 252,0.777);
    font-style: bold;
}

.centrar {
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center; /* Centra las columnas horizontalmente */
    align-items: center; /* Centra las filas verticalmente */    
}

.error {
    color: red;
    justify-content: center; /* Centra las columnas horizontalmente */
    align-items: center; /* Centra las filas verticalmente */    
}
`, "",{"version":3,"sources":["webpack://./src/css/Iniciar_sesion.css"],"names":[],"mappings":"AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB,EAAE,2BAA2B;IAChD,uBAAuB,EAAE,yBAAyB;IAClD,kBAAkB;AACtB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB,EAAE,2BAA2B;IAChD,uBAAuB,EAAE,yBAAyB;IAClD,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,uBAAuB,EAAE,wCAAwC;IACjE,mBAAmB,EAAE,mCAAmC;IACxD,wBAAwB;IACxB,0CAA0C;IAC1C,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,yBAAyB;IACzB,wBAAwB;IACxB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB,EAAE,wCAAwC;IAChE,mBAAmB,EAAE,mCAAmC;IACxD,kBAAkB;IAClB,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,uBAAuB,EAAE,wCAAwC;IACjE,mBAAmB,EAAE,mCAAmC;IACxD,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,YAAY;IACZ,mBAAmB;AACvB;;;AAGA;IACI,gBAAgB;IAChB,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,2CAA2C;IAC3C,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB,EAAE,wCAAwC;IACjE,mBAAmB,EAAE,mCAAmC;AAC5D;;AAEA;IACI,UAAU;IACV,uBAAuB,EAAE,wCAAwC;IACjE,mBAAmB,EAAE,mCAAmC;AAC5D","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Gupter:wght@400&display=swap\");\r\n\r\n.contenedor_registro_i {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center; /* Centra horizontalmente */\r\n    justify-content: center; /* Centra verticalmente */\r\n    text-align: center;\r\n}\r\n\r\n\r\n.principal {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center; /* Centra horizontalmente */\r\n    justify-content: center; /* Centra verticalmente */\r\n    text-align: center;\r\n    margin-top: 20px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.formulario_login_i {\r\n    font: 1.4em Gupter;\r\n    display: block;\r\n    justify-content: center; /* Centra las columnas horizontalmente */\r\n    align-items: center; /* Centra las filas verticalmente */\r\n    border: double 7px white;\r\n    background-color:rgb(158, 224, 252, 0.777);\r\n    margin-bottom: 20px;\r\n    margin-top: 20px;\r\n    border-radius: 20px;\r\n    padding-top: 20px;\r\n    padding-bottom: 20px;\r\n}\r\n\r\n.titulo_l {\r\n    font: 1.8em Gupter;\r\n    display: flex;\r\n    text-align: center;\r\n    justify-content: center;\r\n    align-items: center;\r\n    font-weight: bold;\r\n    color: white;\r\n    background-color: #545454;\r\n    border: double 7px white;\r\n    border-radius: 20px;\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;\r\n}\r\n\r\n.etiqueta_i {\r\n    display: flex;\r\n    justify-content: right; /* Centra las columnas horizontalmente */\r\n    align-items: center; /* Centra las filas verticalmente */\r\n    padding-right: 5px;\r\n    padding-bottom: 10px;\r\n    color: #333;\r\n}\r\n\r\n.casilla_i {\r\n    justify-content: center; /* Centra las columnas horizontalmente */\r\n    align-items: center; /* Centra las filas verticalmente */\r\n    padding: 5px;\r\n    border-radius: 5px;\r\n    border: double 7px rgb(170, 157, 152);\r\n    color: coral;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n\r\nbutton.boton_login {\r\n    margin-top: 20px;\r\n    color: white;\r\n    background-color: rgb(170, 157, 152);\r\n    padding: 10px;\r\n    border-radius: 20px;\r\n    border: double 7px rgb(158, 224, 252,0.777);\r\n    font-style: bold;\r\n}\r\n\r\n.centrar {\r\n    display: flex;\r\n    flex-direction: column;\r\n    text-align: center;\r\n    justify-content: center; /* Centra las columnas horizontalmente */\r\n    align-items: center; /* Centra las filas verticalmente */    \r\n}\r\n\r\n.error {\r\n    color: red;\r\n    justify-content: center; /* Centra las columnas horizontalmente */\r\n    align-items: center; /* Centra las filas verticalmente */    \r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
